
import { mapActions, mapState, mapGetters } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  name: "AddToCartDialog",
  components: { ResponsiveDialog, currencyConverter },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      valid: false,
      selectedVariant: "",
      selectedChoices: [],
      selectedAddons: [],
      isChoicesMandatory: true,
      variantQuantity: 1,
      loading: false
    };
  },
  async beforeMount() {
    this.variantQuantity = this.item.quantity || 1;
    this.selectedVariant = this.item.variantId || "";
    this.selectedAddons = this.getSelectedAddons(this.item.item_addons.items);
    this.selectedChoices = this.getSelectedChoices(this.item.item_groups.items);
  },
  computed: {
    ...mapState("order", ["cart"])
  },
  methods: {
    ...mapActions("order", [
      "addOrMergeCartItem",
      "replaceCartItem",
      "updateCart"
    ]),
    isValid() {
      if (this.item?.item_addons?.items?.length > 0) {
        const addonsList = this.getFilteredAddons();
        if (!addonsList.length) {
          return false;
        }
        for (const addonGroup of addonsList) {
          const group = this.item.item_addons.items.find(
            (item) => item.id === addonGroup.id
          );
          const { min_selection, max_selection } = group;
          if (min_selection !== null || max_selection !== null) {
            const selectedCount = addonGroup?.selectedIds?.length;
            if (
              selectedCount < min_selection ||
              selectedCount > max_selection
            ) {
              return false;
            }
          }
        }
      }

      return true;
    },
    isAddonSelected(groups, groupId, addonId) {
      const found = groups.find((item) => item.id === groupId) ?? [];
      return found && found.selectedIds && found.selectedIds.includes(addonId);
    },
    isAddonGroupSelectable(id) {
      const group = this.getAddonGroup(id);
      return group.max_selection > 0;
    },
    addonSelectionMessage(id) {
      const group = this.getAddonGroup(id);
      const selectionWord = (count) =>
        count === 1 ? "selection" : "selections";
      if (group.min_selection > 0 && group.max_selection > 0) {
        return `${group.min_selection} addon ${selectionWord(
          group.min_selection
        )} mandatory, and up to ${group.max_selection} ${selectionWord(
          group.max_selection
        )} allowed`;
      }
      return `Up to ${group.max_selection} ${selectionWord(
        group.max_selection
      )} allowed`;
    },
    getSelectedAddons(groups = []) {
      return groups.map((group) => ({
        id: group.id,
        selectedIds: group.addons
          .filter((addon) => addon.item_is_active === 1)
          .map((addon) => ({
            id: addon.id,
            selected: this.item.addonIds
              ? this.isAddonSelected(this.item.addonIds, group.id, addon.id)
              : false
          }))
      }));
    },
    getSelectedChoices(groups = []) {
      return groups.map((group) => ({
        ...group,
        selectedIds: this.item.choiceIds
          ? this.item.choiceIds.find((item) => item.id === group.id)
              .selectedIds[0]
          : null
      }));
    },
    isCheckboxDisabled(addonGroup, addonId) {
      const addonGroupProps = this.getAddonGroup(addonGroup.id);
      const maxSelection = addonGroupProps?.max_selection;
      const selectedCount =
        addonGroup.selectedIds.filter((addon) => addon.selected).length || 0;
      return (
        selectedCount >= maxSelection &&
        !addonGroup.selectedIds.find((addon) => addon.id === addonId)?.selected
      );
    },
    getAddonGroup(groupId) {
      const found = this.item.item_addons.items.find(
        (group) => group.id === groupId
      );
      return found || "";
    },
    getAddonProps(addonId, prop) {
      const addon = this.item.item_addons.items
        .flatMap((group) => group.addons)
        .find((a) => a.id === addonId);
      return addon ? addon[prop] : "";
    },
    getFilteredAddons(removeEmptyGroup) {
      const addons = this.selectedAddons.map((addon) => ({
        ...addon,
        selectedIds: addon.selectedIds
          .filter((id) => id.selected)
          .map((item) => item.id)
      }));
      return removeEmptyGroup
        ? addons.filter((item) => item?.selectedIds?.length > 0)
        : addons;
    },
    handleSubmit() {
      const addonIds = this.getFilteredAddons(true);
      const choiceIds = this.selectedChoices.map((item) => ({
        id: item.id,
        selectedIds: [item.selectedIds]
      }));
      this.loading = true;
      const newCartItem = {
        ...this.item,
        menuId: this.item.id,
        quantity: this.variantQuantity,
        variantId: this.selectedVariant,
        choiceIds,
        addonIds
      };
      // when we update existing item
      if (this.item.quantity) {
        this.replaceCartItem({
          existingCartItem: this.item,
          newCartItem: newCartItem
        });
      } else {
        this.addOrMergeCartItem(newCartItem);
      }
      this.$emit("close-dialog");
      this.loading = false;
    },
    handleClearSelection() {
      this.isChoicesMandatory = false;
      this.selectedChoices = [];
    },
    updateQty(increment) {
      if (increment) {
        this.variantQuantity++;
      } else {
        if (this.variantQuantity > 1) {
          this.variantQuantity--;
        } else if (this.variantQuantity === 1 && !!this.item.quantity) {
          this.updateCart({
            menuItems: [{ ...this.item, menuId: this.item.id, quantity: 0 }]
          });
          this.$emit("close-dialog");
        } else if (!this.item.quantity) {
          this.$emit("close-dialog");
        }
      }
    }
  }
};
